import axios from 'axios';
import applyAuthInterceptors from '@/auth/utils/tokenInterceptor';
import { applyServerErrorInterceptor } from '@modules/support/serverErrorInterceptor';

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

applyAuthInterceptors(axiosInstance);
// Registered after the auth interceptor so a 401 that is recovered by a token refresh
// never surfaces as a failure worth reporting.
applyServerErrorInterceptor(axiosInstance);

export default axiosInstance;
